import Content from "./index";

export default {
  path: "bertha-jobs",
  name: "Bertha Jobs",
  component: Content
};
